import { createContext } from "react";

interface IContext {
  isSignIn: boolean;
  signOut(): void;
}

const defaultValue = {
  isSignIn: false,
  signOut: () => {},
};

const DropboxContext = createContext<IContext>(defaultValue);
DropboxContext.displayName = "DropboxContext";

export default DropboxContext;
